
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from 'app/_globals';
import { NotificationService } from 'app/_services/notification.service';

@Component({
  selector: 'multi-edit-choose-site-type-modal',
  templateUrl: './multi-edit-choose-site-type-modal.component.html',
})
export class MultiEditChooseSiteTypeModalComponent implements OnInit {
  @Input() siteTypes: any[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder,
    public globals: Globals,
  ) { }

  ngOnInit() {
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public submit(siteTypeId) {
    this.activeModal.close(siteTypeId);
  }
}
